import { render, staticRenderFns } from "./DeleteRowIcon.vue?vue&type=template&id=9c20f30a"
import script from "./DeleteRowIcon.vue?vue&type=script&lang=js"
export * from "./DeleteRowIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports